import { __awaiter } from "tslib";
export class SolanaWalletAdapter {
    constructor(adapter) {
        this.adapter = adapter;
        this.connect = () => __awaiter(this, void 0, void 0, function* () {
            yield this.adapter.connect();
        });
    }
    get connected() {
        return this.adapter.connected;
    }
    get autoApprove() {
        return false;
    }
    signAllTransactions(transactions) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.adapter.signAllTransactions(transactions);
        });
    }
    get publicKey() {
        return this.adapter.publicKey;
    }
    signTransaction(transaction) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.adapter) {
                return transaction;
            }
            return this.adapter.signTransaction(transaction);
        });
    }
    disconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.adapter.disconnect();
        });
    }
    on(event, fn) {
        this.adapter.on(event, fn);
    }
}
//# sourceMappingURL=solana.js.map